import styled from "styled-components";
import { useIN12aTrayAmbient } from "../../../hooks/BWOS/useIN12aTrayAmbient";
import { TubeBar } from "./FGChartTube";
import { CircularGauge } from "./CircularGauge";
import { useOrientation } from "../../../hooks/useOrienttation";

const PortraitWrapper = styled.div`
  display: flex;
  flex-direction: row;
`;
const ChartWrapper = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  width: 100%;
`;

const ExtendedBarStyle = styled.div`
  display: flex;
  gap: 0.6rem;
  justify-content: center;
  flex-wrap: wrap;
  margin-top: 2rem;
`;

const GlobalGaugesWrapper = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 2rem;
  margin-top: -1rem;
`;

const PortraitGaugesWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-right: 3rem;
  margin-top: -1rem;
`;

function TrayAmbientFG({ height }) {
  const { data, isLoading, error } = useIN12aTrayAmbient();
  const orientation = useOrientation();
  const isPortrait = orientation === "portrait";

  if (isLoading) return <div>Loading...</div>;
  if (error) return <div>Error loading data</div>;

  const maxTotalSpace = Math.max(...data.map((c) => c.spaceTotal));

  const getFillGrade = (occupied, total) =>
    total > 0 ? (occupied / total) * 100 : 0;

  let totalOccupied = 0,
    totalSpace = 0,
    totalOccupied200 = 0,
    totalSpace200 = 0,
    totalOccupied290 = 0,
    totalSpace290 = 0,
    totalOccupied425 = 0,
    totalSpace425 = 0;

  const enrichedData = data?.map((crane) => {
    totalOccupied += crane.occupiedTotal;
    totalSpace += crane.spaceTotal;
    totalOccupied200 += crane.occupied200;
    totalSpace200 += crane.space200;
    totalOccupied290 += crane.occupied290;
    totalSpace290 += crane.space290;
    totalOccupied425 += crane.occupied425;
    totalSpace425 += crane.space425;

    const fillTotal = getFillGrade(crane.occupiedTotal, crane.spaceTotal);
    return {
      ...crane,
      fillTotal,
      fill200: getFillGrade(crane.occupied200, crane.space200),
      fill290: getFillGrade(crane.occupied290, crane.space290),
      fill425: getFillGrade(crane.occupied425, crane.space425),
    };
  });

  const globalFill = {
    total: getFillGrade(totalOccupied, totalSpace).toFixed(1),
    h200: getFillGrade(totalOccupied200, totalSpace200).toFixed(1),
    h290: getFillGrade(totalOccupied290, totalSpace290).toFixed(1),
    h425: getFillGrade(totalOccupied425, totalSpace425).toFixed(1),
  };

  const maxFill = Math.max(...enrichedData.map((c) => c.fillTotal));

  return (
    <>
      {isPortrait ? (
        <PortraitWrapper>
          <ChartWrapper>
            <ExtendedBarStyle>
              {enrichedData.map((crane) => (
                <TubeBar
                  key={crane.crane}
                  yValue={crane.occupiedTotal}
                  refValue={null}
                  maxYValue={crane.spaceTotal}
                  label={crane.crane}
                  machine={crane.crane}
                  color="var(--color-grey-500)"
                  height={height}
                />
              ))}
            </ExtendedBarStyle>
          </ChartWrapper>
          <PortraitGaugesWrapper>
            <CircularGauge value={+globalFill.total} label="Total" />
          </PortraitGaugesWrapper>
          <PortraitGaugesWrapper>
            <CircularGauge value={+globalFill.h200} label="200" />
            <CircularGauge value={+globalFill.h290} label="290" />
            <CircularGauge value={+globalFill.h425} label="425" />
          </PortraitGaugesWrapper>
        </PortraitWrapper>
      ) : (
        <ChartWrapper>
          <ExtendedBarStyle>
            {enrichedData.map((crane) => (
              <TubeBar
                key={crane.crane}
                yValue={crane.occupiedTotal}
                refValue={null}
                maxYValue={crane.spaceTotal}
                label={crane.crane}
                machine={crane.crane}
                color="var(--color-grey-500)"
                height={height}
              />
            ))}
          </ExtendedBarStyle>
          <GlobalGaugesWrapper>
            <CircularGauge value={+globalFill.total} label="Total" />
            <CircularGauge value={+globalFill.h200} label="200" />
            <CircularGauge value={+globalFill.h290} label="290" />
            <CircularGauge value={+globalFill.h425} label="425" />
          </GlobalGaugesWrapper>
        </ChartWrapper>
      )}
    </>
  );
}

export default TrayAmbientFG;
